import {
  ThumbsupIcon,
  ThumbsdownIcon,
  ThumbsupSelectedIcon,
  ThumbsdownSelectedIcon,
} from "../assets/icons";
import { Stack } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import styles from "./styles.module.scss";
import { useState } from "react";
import { CustomMultilineInput } from "./Form";
import { openChat, sendFeedback } from "../api";

enum FeedbackState {
  None = "",
  Positive = "good",
  Negative = "bad",
}

function Feedback({ close }: { close: () => void }) {
  const [feedbackState, setFeedbackState] = useState(FeedbackState.None);
  const [feedbackInput, setFeedbackInput] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  return (
    <Stack direction="column" className="p-2 al-h-full">
      <Stack direction="row" className="mb-2">
        <div className="fw-semibold fs-5">Feedback</div>
        <div className="spacer"></div>
        <Button
          size="sm"
          onClick={e => {
            e.stopPropagation();
            openChat();
          }}
        >
          Chat with us
        </Button>
      </Stack>
      <div className={styles.feedback_body}>
        {!isSubmitted && (
          <>
            <Stack direction="row" gap="sm" className="m-2">
              {feedbackState === FeedbackState.Positive ? (
                <ThumbsupSelectedIcon
                  className="cursor-pointer"
                  onClick={() => setFeedbackState(FeedbackState.None)}
                />
              ) : (
                <ThumbsupIcon
                  className="cursor-pointer"
                  onClick={() => setFeedbackState(FeedbackState.Positive)}
                />
              )}
              {feedbackState === FeedbackState.Negative ? (
                <ThumbsdownSelectedIcon
                  className="cursor-pointer"
                  onClick={() => setFeedbackState(FeedbackState.None)}
                />
              ) : (
                <ThumbsdownIcon
                  className="cursor-pointer"
                  onClick={() => setFeedbackState(FeedbackState.Negative)}
                />
              )}
            </Stack>
            <p>AI still needs humans sometimes, please help it out 🙂</p>
            <CustomMultilineInput
              value={feedbackInput}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setFeedbackInput(e.target.value)
              }
              placeholder="What did AI do wrong? What it should have done?"
            />
            <Stack direction="row" gap="sm" className="mt-3">
              <Button
                size="sm"
                onClick={async e => {
                  e.stopPropagation();
                  if (feedbackState === FeedbackState.None) return;
                  await sendFeedback({
                    feedback_value: feedbackState,
                    feedback_text: feedbackInput,
                  });
                  setIsSubmitted(true);
                }}
              >
                Submit
              </Button>
              <Button
                size="sm"
                variant="link"
                className={styles.cancel_btn}
                onClick={e => {
                  e.stopPropagation();
                  close();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </>
        )}
        {isSubmitted && (
          <>
            <p>Many thanks for your feedback!</p>
            <Button
              size="sm"
              onClick={e => {
                e.stopPropagation();
                close();
              }}
            >
              Close
            </Button>
          </>
        )}
      </div>
    </Stack>
  );
}

export { Feedback };
